import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useRef } from 'react';
import { BKJIcon } from '../BKJIcon/index.js';
import { Flex } from '../Flex/index.js';
import { BKJEllipsisMenuUIStateProvider, useBKJEllipsisMenuUIStateContext, } from './BKJEllipsisMenu.context.js';
import { BKJEllipsisMenuIconWrapper } from './BKJEllipsisMenu.styled.js';
import { BKJEllipsisMenuDropdown } from './BKJEllipsisMenuDropdown.js';
const Component = ({ triggerRef, children }) => {
    const { toggleMenu, isOpen } = useBKJEllipsisMenuUIStateContext();
    return (_jsxs(Fragment, { children: [_jsx(BKJEllipsisMenuIconWrapper, { onClick: toggleMenu, children: _jsx(Flex, { ref: triggerRef, height: "38px", minHeight: "38px", justifyContent: "center", alignItems: "center", children: _jsx(BKJIcon, { iconName: "Ellipsis" }) }) }), isOpen && triggerRef.current && (_jsx(BKJEllipsisMenuDropdown, { triggerRef: triggerRef, children: children }))] }));
};
export const BKJEllipsisMenu = ({ children, ...props }) => {
    const triggerRef = useRef(null);
    return (_jsx(BKJEllipsisMenuUIStateProvider, { children: _jsx(Component, { ...props, triggerRef: triggerRef, children: children }) }));
};
//# sourceMappingURL=BKJEllipsisMenu.js.map